"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  ACTION: 'Action',
  ADD: 'Add',
  ADD_POLICY_BTN: 'Add Policy',
  BACK_TO_SYS_ADMIN_BUTTON: 'Back To System Administration',
  CANCEL: 'Cancel',
  CANCEL_MODAL_MSG: 'The changes will not be saved.',
  CLOSE: 'Close',
  CLONE: 'Clone',
  CONSUMER: 'Consumer',
  COPY: 'Copy',
  COPY_OF: 'copy_of_{{name}}',
  COPY_NOTIFICATION_MESSAGE: 'JSON has been copied to clipboard.',
  DAYS: 'Days',
  DELETE: 'Delete',
  DESCRIPTION: 'Description',
  DENY: 'Deny',
  DISABLE: 'Disable',
  DISABLED: 'Disabled',
  DISCARD: 'Discard Changes?',
  DISCARD_AND_SWITCH_TO_JSON: 'Discard Changes and Switch to JSON?',
  DISCARD_AND_SWITCH_TO_FORM: 'Discard Changes and Switch to Form?',
  DISCARD_AND_SWITCH_TO_JSON_MSG: 'Switching to JSON mode will discard all changes made on form.',
  DISCARD_AND_SWITCH_TO_FORM_MSG: 'Switching to Form mode will discard all changes made in the JSON.',
  DATA_NOT_FETCHED_SUCCESSFULLY: 'Data not fetched successfully.',
  DESCRIPTION_MAX_CHAR: 'Description must be less than 255 characters',
  DRAFT: 'Draft',
  ENABLE: 'Enable',
  ENABLED: 'Enabled',
  EDIT: 'Edit',
  ERROR_MESSAGE: '{{ reason }}.',
  MIN_APPROVAL_DAYS: 'Min number of days 1 is required, for Access validity after approval',
  HOURS: "{{hours}} Hours",
  INVALID_JSON: 'Invalid Json',
  INACTIVE_TEXT: 'Inactive',
  JSON_COPIED: 'JSON has been copied to clipboard.',
  LOADING: 'Loading...',
  NO: 'No',
  NO_KEEP_CHANGES: 'No, Keep Changes',
  NONE: 'None',
  MINUTES: '{{minutes}} Minutes',
  NO_ACCESS_To_POLICY_ADMIN: "You don't have access to Roles & Policy Management",
  PERMISSIONS: 'Permissions',
  PERMISSION: 'Permission',
  PERMISSION_NAME: 'Permission Name',
  POLICIES: 'Policies',
  POLICIES_LOADING: 'Loading Policy Data...',
  SWITCH_TO_JSON_BTN: 'Discard Changes and Switch to JSON',
  SWITCH_TO_FORM_BTN: 'Discard Changes and Switch to Form',
  SWITCH_TO_JSON_HEADER: 'Switch to JSON?',
  SWITCH_TO_FORM_HEADER: 'Switch to Form?',
  YES: 'Yes',
  POLICIES_MODULE: {
    INPUT_NAME_MAX_CHAR: 'Name must be between 1 and 128 characters',
    NAME_CHAR_VALIDATION: 'Name should only contain alphabets, numbers or special chars: underscore ( _ ) and hyphen ( - )',
    MEMBERS_DIALOG_TITLE: 'Policy Will be Disabled!',
    MEMBERS_DIALOG_MESSAGE: 'While saving the changes the policy will be disabled as it does not have any members.',
    MEMBERS_DIALOG_SECONDARY_BUTTON: 'Cancel',
    MEMBERS_DIALOG_PRIMARY_BUTTON: 'Disable policy and save changes',
    LOADING_MEMBERS: 'Loading Members...',
    ACCESS_VALIDITY_AFTER_APPROVAL_LABEL: 'Approval Validity',
    ADDING_POLICY: 'Adding Policy...',
    ALL_USERS: 'All Users',
    ALL_TAGS: 'All Tags',
    ALL_SERVICE_IDENTITIES: 'All Service Identities',
    ALL_TOKENS: 'All Tokens',
    ADD_PERMISSION_DUPLICATE: 'The permission could not be added to the list as it already exists.',
    ADD_PERMISSION_SUCCESS: 'The permission is added to the list.',
    ADD_TAGS: 'Select Tags',
    ADD_POLICY: 'Add Policy',
    BACK: 'Back',
    CHANNEl_MIN: 'At least one channel is required.',
    CHANNEL_LIST_LABEL: 'Channel List',
    CHANNEL_LIST_PLACEHOLDER: 'Search Channels',
    CHANNEL_LIST_HELPER_TEXT: "Comma separated list of channels",
    EDIT_POLICY: 'Edit Policy',
    DISABLED_DELETE_POLICY_TOOLTIP: 'Predefined policy can not be deleted',
    DISABLED_TA_DELETE_TOOLTIP: 'Tenant Admin policy can not be deleted',
    ERROR_GET_ROLE_LIST: 'Unable to get the roles {{reason}}',
    ERROR_GET_PERMISSION_LIST: 'Unable to get the permissions {{reason}}',
    WARNING_GET_PERMISSION_LIST: 'Unable to fetch all permissions {{reason}}',
    WARNING_GET_CHANNEL_LIST: 'Unable to fetch all channels {{reason}}',
    WARNING_GET_ROLE_LIST: 'Unable to fetch all roles {{reason}}',
    READONLY_POLICY_JSON_MESSAGE: 'Predefined Policies can not be updated through JSON',
    ADD_POLICY_SUCCESS: 'Policy created Successfully.',
    ACCESS_TYPE: 'Access Type',
    CANCEL_ADD_POLICY: 'The unsaved changes to the policy will be discarded.',
    CLONE_POLICY_TOOLTIP: 'Clone policy',
    DISABLE_TOOLTIP: 'Disable policy',
    DISABLE_FOR_USER_TOOLTIP: 'Tenant Admin Policy can not be disabled',
    DELETE_POLICY_CONFIRM_TITLE: 'Delete Policy?',
    DELETE_POLICY_CONFIRM_MESSAGE: 'The policy will be deleted permanently.',
    DELETE_POLICY_SUCCESS_MESSAGE: 'The policy was deleted successfully.',
    DELETE_POLICY_ERROR_MESSAGE: 'The policy could not be deleted.',
    DELETE_POLICY_TOOLTIP: 'Delete policy',
    EDITING_POLICY: 'Editing Policy...',
    ENABLE_TOOLTIP: 'Enable policy',
    DRAFT_ENABLE_TOOLTIP: 'Draft policy can not be enabled',
    TIME_VALIDATION: 'At least one date/time option must be selected',
    END_DATE_TIME_VALIDATION: 'End date time should be later than start date time',
    END_DATE_TIME_GREATER_THEN_TODAY_VALIDATION: 'End date time should be later than current date time',
    END_TIME_VALIDATION: 'End time should be later than start time',
    INLINE_POLICY_SUCCESS_MESSAGE: 'The inline permission is added to the list.',
    INLINE_POLICY_UNIQUE_NAME_MESSAGE: 'An inline permission with same name already exists.',
    IP_ADDRESS_INVALID: 'Invalid IP Address',
    MANAGE_POLICY_TOOLTIP: 'Manage policy',
    POLICY_CREATED: 'The policy created successfully.',
    POLICY_UPDATE_SUCCESS: 'Policy Updated Successfully.',
    POLICY_IN_JSON_FORMAT: 'Policy in JSON Format',
    POLICY_NOT_CREATED: 'The policy could not be created.',
    ROLE_DELETE_MODAL_MESSAGE: 'The role will be removed from the list.',
    SAVE_POLICY_DIALOG_MESSAGE: 'Changes to the policy will be saved.',
    SAVE_POLICY_DIALOG_TITLE: 'Save Policy?',
    SAVE_AND_ENABLE: 'Save and Enable',
    SAVE_DRAFT: 'Save Draft',
    START_DATE_TIME_MESSAGE: 'Start date time should be in future and before end date time',
    TOGGLE_POLICY_CONFIRM_TITLE: '{{toggleType}} Policy?',
    TOGGLE_POLICY_CONFIRM_TITLE_DISABLE: 'Disable Policy?',
    TOGGLE_POLICY_CONFIRM_TITLE_ENABLE: 'Enable Policy?',
    TOGGLE_POLICY_CONFIRM_MESSAGE: 'The policy will be {{nextValue}}.',
    TOGGLE_POLICY_CONFIRM_MESSAGE_DISABLE: 'The policy will be disabled.',
    TOGGLE_POLICY_CONFIRM_MESSAGE_ENABLE: 'The policy will be enabled.',
    TOGGLE_POLICY_SUCCESS_MESSAGE: 'The Policy was {{nextValue}}.',
    TOGGLE_POLICY_SUCCESS_MESSAGE_DISABLE: 'The Policy was disabled.',
    TOGGLE_POLICY_SUCCESS_MESSAGE_ENABLE: 'The Policy was enabled.',
    TOGGLE_POLICY_ERROR_MESSAGE: 'The Policy could not be {{nextValue}}.',
    TOGGLE_POLICY_ERROR_MESSAGE_DISABLE: 'The Policy could not be disabled.',
    TOGGLE_POLICY_ERROR_MESSAGE_ENABLE: 'The Policy could not be enabled.',
    POLICY_NAME: 'Policy Name',
    POLICY_NAME_REQUIRED: 'Policy Name is required',
    POLICY_NAME_UNIQUE: 'Policy Name already exists.',
    PERMISSION_NAME_UNIQUE: 'Permission Name already exists.',
    DESCRIPTION_LENGTH_MAX: 'Description can not be longer than 255 characters.',
    USERS_LABEL: 'Users',
    USERS_MIN: 'At least one user is required.',
    GROUPS_LABEL: 'Tags',
    GROUPS_MIN: 'At least one tag is required.',
    HOURS_MINS: 'Hours:Minutes',
    DAYS: 'Days',
    TOKEN_LABEL: 'API Tokens',
    TOKENS_MIN: 'At least one token is required.',
    RESET_EDIT_TITLE: 'Reset Policy Changes?',
    RESET_EDIT_MESSAGE: 'All fields will be replaced with saved policy',
    RESET_EDIT_PRIMARY_BTN: 'Yes, Reset All fields',
    RESET_EDIT_SECONDARY_BTN: 'No, Keep Changes',
    SERVICE_IDENTITIES_LABEL: 'Service Identities',
    SERVICE_IDENTITIES_MIN: 'At least one service Identity is required.',
    NO_ACCESS_TO_CLONE_POLICY: "You don't have access to clone policy",
    NO_ACCESS_TO_DELETE_POLICY: "You don't have access to delete policy",
    NO_ACCESS_TO_MANAGE_POLICY: "You don't have access to manage policy",
    NO_ACCESS_TO_ENABLE_POLICY: "You don't have permission to enable the policy",
    NO_ACCESS_TO_DISABLE_POLICY: "You don't have permission to disable the policy",
    MEMBER_VALIDATION: 'At least one Member is required.',
    NOTIFICATION_MEDIUM_LABEL: 'Notification Medium',
    NOTIFICATION_MEDIUM_MIN: 'At least one notification medium for approvals is required.',
    NOTIFICATION_MEDIUM_PLACEHOLDER: 'Select Notification Medium',
    ROLES_PERMISSION_ONE_OF: 'At least one role or permission is required.',
    ALLOW: 'Allow',
    APPROVERS_LABEL: 'Approvers',
    APPROVERS_SUB_LABEL: 'Approval from any one is sufficient',
    APPROVERS_PLACEHOLDER: 'Search Approvers',
    APPROVAL_LABEL: 'Approval Required',
    APPROVER_TYPE_LABEL: 'Approver Type',
    APPROVER_TYPE_ONE_OF: 'Approver type can be one of users,tags or channels.',
    APPROVERS_MIN: 'At least one approver is required.',
    APPROVER_TIME_LABEL: 'Maximum time to Approve',
    IP_ADDRESS_LABEL: 'IP Addresses',
    IP_ADDRESS_HELPER_TEXT: 'Specify comma separated IP addresses in CIDR or dotted decimal format',
    IP_ADDRESS_SUB_LABEL: 'Specify comma separated IP addresses in CIDR format',
    IP_ADDRESS_RADIO_LABEL: 'Do you want to specify conditions based on IP address?',
    IP_ADDRESS_REQUIRED: 'IP Address is required',
    TIMEZONE_REQUIRED: 'Timezone is required',
    DATE_TIME_RADIO_LABEL: 'Do you want to specify conditions based on Date/Time?',
    START_DATE_TIME_REQUIRED: 'Start Date-time is required',
    START_DATE_TIME_LABEL: 'Start Date/Time',
    END_DATE_TIME_REQUIRED: 'End Date-time is required',
    END_DATE_TIME_LABEL: 'End Date/Time',
    START_TIME_REQUIRED: 'Start Time and End Time are required',
    START_TIME_VALIDATION: 'Start Time should be before End Time.',
    START_TIME_LABEL: 'From',
    END_TIME_REQUIRED: 'End Time is required',
    SELECTED_DAYS_REQUIRED: 'At least one day must be selected.',
    END_TIME_LABEL: 'To',
    SPECIFY_DATE_TIME_LABEL: 'Specify Start and End Date/Time',
    START_AND_END_DATE_TIME: 'Start and End Date/Time',
    DATE_TIME_SCHEDULE: 'Date and Time Schedule',
    SET_TIME_LABEL: 'Set Time Schedule',
    TIMEZONE_LABEL: 'Timezone',
    STEP_UP_VERIFICATION_RADIO_LABEL: 'Require step-up verification?',
    STEP_UP_VERIFICATION_ALWAYS_PROMPT_RADIO_LABEL: 'Remember previous successful Verification?',
    STEP_UP_VERIFICATION_VIEW_LABEL: 'Step-up Verification enabled?',
    STEP_UP_VERIFICATION_ALWAYS_PROMPT_VIEW_LABEL: 'Always prompt for Verification?',
    STEP_UP_VERIFICATION_ALWAYS_PROMPT_RADIO_LABEL_TOOLTIP: 'Verification validity is configured in the step up verification validity settings for your organization.',
    MAX_APPROVAL_REQUIRED: 'Max approval time is required.',
    MAX_APPROVAL_FORMAT: 'Max approvals should be in hours:minutes format',
    MAX_VALID_TIME_AFTER_APPROVAL_REQUIRED: 'Access validity after approval is required.',
    MAX_VALID_TIME_AFTER_APPROVAL_FORMAT: 'Access validity after approval should be in hours:minutes format',
    POLICY_JSON_NOT_EMPTY: 'The Policy JSON can not be empty',
    REMOVE_APPROVALS_TITLE: 'Remove Approvals?',
    REMOVE_APPROVALS_MESSAGE: "'Deny' policy does not need approvals. 'Approvals' tab will be removed. Data on this tab will be lost",
    SEARCH_POLICY: 'Search by Policy Name',
    DELETE_POLICY_ERROR_MESSAGE_WITH_REASON: 'The policy could not be deleted,  {{reason}}.',
    VIEW_POLICY_ERROR_MESSAGE_WITH_REASON: 'Unable to get policy data,  {{reason}}.',
    EDIT_POLICY_ERROR_MESSAGE_WITH_REASON: 'Unable to draft policy data,  {{reason}}.',
    POLICY_CLONE: 'Policy cloned to clipboard.',
    POLICY_JSON_FORMAT: 'Policy in Json Format',
    POLICY_JSON_COPIED: 'The policy JSON was copied.',
    POLICY_JSON_EMPTY: 'The Policy JSON was empty.',
    DELETE_POLICY: 'Delete Policy?',
    USERS: 'Users',
    USER_LIST_LABEL: 'User List',
    NO_USERS_FOUND: '*No users present in the system',
    NO_TAGS_FOUND: '*No tags present in the system',
    NO_TOKENS_FOUND: '*No API tokens present in the system',
    NO_SI_FOUND: '*No service identities present in the system',
    USER_LIST_PLACEHOLDER: 'User List',
    TAG_LIST_LABEL: 'Tag List',
    TAG_LIST_PLACEHOLDER: 'Search Tags',
    TAGS: 'Tags',
    SERVICE_IDENTITIES: 'Service identities',
    API_TOKENS: 'API Tokens',
    IP_ADDRESS: 'IP Addresses',
    START_TIME: 'Start Date/Time',
    END_TIME: 'End Date/Time',
    APPROVAL_REQUIRED: 'Approval Required?',
    MANAGER_APPROVAL_MANDATORY: 'Manager Approval Mandatory?',
    NOTIFICATION_MEDIUM: 'Notification Medium',
    APPROVER_TYPE: 'Approver Type',
    APPROVERS: 'Approvers',
    MAXIMUM_TIME: 'Maximum Time to Approve',
    GENERAL: 'General',
    MEMBERS: 'Members',
    GENERIC_CONDITIONS: 'Generic Conditions',
    APPROVALS: 'Approvals',
    STEP_UP_VERIFICATION: 'Step-up Verification',
    ENABLE_LOADING_MESSAGE: 'Enabling Policy...',
    DISABLE_LOADING_MESSAGE: 'Disabling Policy...',
    VIEW_ROLE_POLICY_TOOLTIP: 'View role',
    YES_REMOVE_APPROVALS: 'Yes, Remove approvals',
    LOADING_METADATA: 'Loading metadata....'
  },
  PERMISSION_MODULE: {
    ADD_PERMISSION: 'Add Permission',
    CANCEL_SAVE_PERMISSION: 'The unsaved changes to the permission will be discarded.',
    CLONE_PERMISSION_TOOLTIP: 'Clone permission',
    DELETE_PERMISSION: 'Delete Permission?',
    DELETE_PERMISSION_MSG: 'The permission will be deleted permanently.',
    DELETE_PERMISSION_TOOLTIP: 'Delete permission',
    DELETE_PERMISSION_ERROR_MESSAGE: 'The permission could not be deleted. It is used in one or more configurations.',
    DISABLED_DELETE_PERMISSION_TOOLTIP: 'Predefined permission can not be deleted',
    EDIT_PERMISSION_TOOLTIP: 'Edit permission',
    FIELD_REPLACE_MSG: 'All field will be replaced with the saved permissions.',
    MANAGE_PERMISSION_TOOLTIP: 'Manage permission',
    NO_ACCESS_TO_CLONE_PERMISSION: "You don't have access to clone permission",
    NO_ACCESS_TO_DELETE_PERMISSION: "You don't have access to delete permission",
    NO_ACCESS_TO_MANAGE_PERMISSION: "You don't have access to manage permission",
    PERMISSIONS_LOADING: 'Loading Permissions ...',
    PERMISSION_COPIED: 'Permission copied to clipboard.',
    PERMISSION_CLONE: 'Permission clone to clipboard.',
    PERMISSION_SAVE_MSG: 'Changes to the permission will be saved.',
    PERMISSION_IN_JSON_FORMAT: 'Permission in JSON Format',
    PERMISSION_EDIT: 'Edit Permission',
    PERMISSION_RESET: 'Reset Permission?',
    PERMISSION_NAME_EXIT: 'Permission name already exists.',
    PERMISSION_NAME_ENTER: 'Please enter name of the permission.',
    PERMISSION_CONSUMER: 'Please select consumer.',
    PERMISSION_RESOURCE: 'Please enter name of the resources.',
    PERMISSION_RESOURCE_SELECT: 'At least one Resource is required.',
    PERMISSION_ACTION: 'At least one Action is required.',
    PERMISSION_DELETE_SUCCESS: 'The permission was deleted successfully.',
    PERMISSION_DELETE_FAILURE: 'The permission could not be deleted. {{reason}}',
    PERMISSION_NOT_CREATED: 'The permission could not be created.',
    PERMISSION_CREATED: 'The permission is created.',
    PERMISSION_CHANGES_NOT_SAVED: 'Changes to the permissions could not be saved.',
    PERMISSION_CHANGES_SAVED: 'Changes to the permissions are saved.',
    SAVE_PERMISSION: 'Save Permission?',
    SAVE_PERMISSION_MSG: 'A new permission will be created.',
    SEARCH_IN_PERMISSIONS_NAME: 'Search by Permission Name',
    VIEW_PERMISSION_TOOLTIP: 'View permission'
  },
  RESET: 'Reset',
  RESOURCES: 'Resources',
  RESET_ALL_FILED: 'Yes, Reset All Fields',
  RESOURCES_HELPER_TEXT: 'Comma separated list of resources',
  ROLES: 'Roles',
  ROLES_MODULE: {
    ACTION_COLUMN: 'Action',
    ACTION_LABEL: 'Actions',
    ACTION_VALIDATION: 'Please select actions',
    ADD_EXISTING_PERMISSION: 'Add Existing Permission',
    ADD_INLINE_NOTIFICATION: 'The inline permission is added to the list.',
    ADD_NEW_PERMISSION: 'Add New Permission',
    ADD_PERMISSION_NOTIFICATION: 'The permission is added to the list.',
    ADD_ROLE: 'Add Role',
    ADD_ROLE_SUCCESS_MESSAGE: 'The role is created.',
    ADD_ROLE_FAILURE_MESSAGE: 'The role could not be created. {{reason}}',
    CANCEL_MODAL_MESSAGE: 'The unsaved changes to the {{entity}} will be discarded.',
    CANCEL_MODAL_PRIMARY_BTN: 'Yes, Discard Without Saving',
    CANCEL_MODAL_TITLE: 'Discard Changes?',
    CLONE_ROLE_TOOLTIP: 'Clone role',
    CONSUMER_LABEL: 'Consumer',
    CONSUMER_PLACEHOLDER: 'Select Consumer',
    CONSUMER_VALIDATIONS: 'Please select consumer',
    CREATING_ROLE: 'Creating Role...',
    DISABLED_DELETE_ROLE_TOOLTIP: 'Predefined role can not be deleted',
    DELETE_INLINE_NOTIFICATION: 'The inline permission is removed from the list.',
    DELETE_MODAL_INLINE_MESSAGE: 'Inline permission will be removed from the list.',
    DELETE_MODAL_PERMISSION_MESSAGE: 'The permission will be removed from the list.',
    DELETE_MODAL_PRIMARY_BTN: 'Yes, Remove',
    DELETE_MODAL_TITLE: 'Remove Permission?',
    DELETE_PERMISSION_NOTIFICATION: 'The permission is removed from the list.',
    DELETE_ROLE_CONFIRM_TITLE: 'Delete Role?',
    DELETE_ROLE_CONFIRM_MESSAGE: 'The role will be deleted permanently.',
    DELETE_ROLE_SUCCESS_MESSAGE: 'The role was deleted successfully.',
    DELETE_ROLE_ERROR_MESSAGE: 'The role could not be deleted. - {{reason}}.',
    DELETE_ROLE_LOADER_MESSAGE: 'Deleting Role...',
    DELETE_ROLE_MESSAGE: 'The role could not be deleted. It is used in one or more configurations.',
    DELETE_ROLE_TOOLTIP: 'Delete role',
    DELETE_PERMISSION_TOOLTIP: 'Delete permission',
    DESCRIPTION_HELPER_LABEL: 'Optional',
    DESCRIPTION_LABEL: 'Description',
    EDIT_PERMISSION_TITLE: 'Edit Permission',
    EDIT_ROLE_ERROR_MESSAGE: 'Changes to the role could not be saved. {{reason}}.',
    EDIT_ROLE_SUCCESS_MESSAGE: 'Changes to the role are saved.',
    EDIT_ROLE_TITLE: 'Edit Role',
    INPUT_NAME_MAX_CHAR: 'Name must be between 1 and 64 characters',
    INPUT_NAME_MAX_CHAR_PERM: 'Name must be between 1 and 128 characters',
    JSON_TEXTAREA_LABEL: 'Role in JSON Format',
    MANAGE_ROLE_TOOLTIP: 'Manage role',
    NO_ACCESS_TO_CLONE_ROLE: "You don't have access to clone role",
    NO_ACCESS_TO_DELETE_ROLE: "You don't have access to delete role",
    NO_ACCESS_TO_MANAGE_ROLE: "You don't have access to manage role",
    NONE: 'None',
    PERMISSION_LABEL: 'Permissions',
    PERMISSION_LOADING: 'Loading Permission Data...',
    PERMISSION_NAME_VALIDATION: 'Please enter name of the permission.',
    PERMISSION_NAME_LABEL: 'Permission Name',
    PERMISSION_TITLE: 'Permission',
    PERMISSION_VALIDATION: 'Please add at least one permission',
    RESET_MODAL_MESSAGE: 'All fields will be replaced with the saved permission.',
    RESET_MODAL_ROLE_MESSAGE: 'All fields will be replaced with the saved role.',
    RESET_MODAL_PRIMARY_BTN: 'Yes, Reset All Fields',
    RESET_MODAL_SECONDARY_BTN: 'No, Keep Changes',
    RESET_MODAL_TITLE: 'Reset Permission?',
    RESET_MODAL_ROLE_TITLE: 'Reset Role?',
    RESET_NOTIFICATION: 'All fields are replaced with saved values.',
    RESOURCE_HELPER_LABEL: 'Comma separated list',
    RESOURCE_LABEL: 'Resources',
    RESOURCE_VALIDATION: 'Please add resources of the permission.',
    ROLE_JSON_VALIDATION: 'Please enter role in JSON format.',
    ROLE_LABEL: 'Role Name',
    ROLES_LOADING: 'Loading Roles Data...',
    ROLE_DETAILS_LOADING: 'Loading Role Details...',
    ROLE_NAME: 'Role Name',
    ROLE_NAME_VALUE: 'Role : {{name}}',
    ROLE_NAME_VALIDATION: 'Please enter name of the role.',
    ROLE_NAME_EXIST_VALIDATION: 'Role name already exist.',
    SAVE_INLINE_PERMISSION: 'Changes to the inline permission are saved.',
    SAVE_MODAL_MESSAGE: 'Changes to the inline permission will be saved.',
    SAVE_MODAL_PRIMARY_BTN: 'Yes, Save',
    SAVE_MODAL_ROLE_MESSAGE: 'Changes to the role will be saved.',
    SAVE_MODAL_ROLE_TITLE: 'Save Role?',
    SAVE_MODAL_TITLE: 'Save Permission?',
    SEARCH_PERMISSION_LABEL: 'Search Permission',
    SEARCH_ROLE_NAME_MESSAGE: 'Search by Role Name',
    SOURCE: 'Source',
    CONSUMER: 'Consumer',
    ACTIONS: 'Actions',
    SOURCE_LABEL: 'Source',
    SUBMIT_FORM_ERROR_TITLE: 'Error submitting form',
    SWITCH_TO_FORM: 'Switch to Form',
    SWITCH_TO_FORM_BTN: 'Discard Changes and Switch to Form',
    SWITCH_TO_FORM_HEADER: 'Switch to Form?',
    SWITCH_TO_FORM_MESSAGE: 'Switching to Form mode will discard all changes made in the JSON.',
    SWITCH_TO_JSON: 'Switch to JSON',
    SWITCH_TO_JSON_BTN: 'Discard Changes and Switch to JSON',
    SWITCH_TO_JSON_HEADER: 'Switch to JSON?',
    SWITCH_TO_JSON_MESSAGE: 'Switching to JSON mode will discard all changes made on form.',
    ROLES_CLONE: 'Role clone to clipboard.',
    GET_ROLE_ERROR_MESSAGE: 'Unable load data. - {{reason}}.',
    UPDATE_ROLE_LOADER_MESSAGE: 'Updating Role..'
  },
  'ROLE_&_POLICY_MANAGEMENT': 'Role & Policy Management',
  SAVE: 'Save',
  SEARCH: 'Search',
  SEARCH_POLICY: 'Search for Policies',
  SELECT_CONSUMER: 'Select Consumer',
  STATUS: 'Status',
  SWITCH_TO_JSON: 'Switch to JSON',
  SWITCH_TO_FORM: 'Switch to Form',
  SWITCH_TO_FORM_BUTTON: 'Switch to Form',
  SWITCH_TO_JSON_BUTTON: 'Switch to JSON',
  SYSTEM_ADMINISTRATION: 'System Administration',
  YES_DELETE: 'Yes, Delete',
  YES_DISABLE: 'Yes, Disable',
  YES_ENABLE: 'Yes, Enable',
  YES_SAVE: 'Yes, Save',
  YES_DISCARD: 'Yes, Discard Without Saving',
  OPTIONAL: 'Optional',
  VIEW_JSON: 'View JSON',
  VIEW_ENTITY: 'View Entity',
  POLICY: 'Policy',
  ROLE: 'Role',
  MAIN: 'main',
  INLINE: 'Inline',
  PRE_DEFINED: 'Predefined'
};
exports.default = _default;